import { render, staticRenderFns } from "./InternalManagement.vue?vue&type=template&id=39d5a888"
import script from "./InternalManagement.vue?vue&type=script&lang=js"
export * from "./InternalManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports